import { ObjectHelpers } from "../../helpers/object-helpers";

export class DrawOrderExecutionModel {
    public tooltip = '';
    public symbol = '';
    public imageAnnotationName = '';
    public x = 0;
    public y = 0;

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }

    public getImageAndClass(basePath: string): Array<string> {
        if (this.imageAnnotationName == 'EXECUTION_BUY_TO_COVER_LIGHT' || this.imageAnnotationName == 'EXECUTION_BUY_TO_COVER_DARK') {
            return [basePath + 'assetfiles/img/B_pointingLeft.png', 'left'];
        } else if (this.imageAnnotationName == 'EXECUTION_BUY_LIGHT' || this.imageAnnotationName == 'EXECUTION_BUY_DARK') {
            return [basePath + 'assetfiles/img/B_pointingRight.png', 'right'];
        } else if (this.imageAnnotationName == 'EXECUTION_SELL_LIGHT' || this.imageAnnotationName == 'EXECUTION_SELL_DARK') {
            return [basePath + 'assetfiles/img/S_pointingLeft.png', 'left'];
        } else if (this.imageAnnotationName == 'EXECUTION_SHORT_LIGHT' || this.imageAnnotationName == 'EXECUTION_SHORT_DARK') {
            return [basePath + 'assetfiles/img/S_pointingRight.png', 'right'];
        }
        return ['', ''];
    }
}